import React from 'react';
import '../../styles/landing/landing.scss';
import Grid from '@material-ui/core/Grid';
import '../../styles/info-pages/info-pages.scss';
import { Link } from 'react-router-dom';
import Footer from '../includes/Footer';
import TermsItem from './TermsItem';
import HeaderAuth from '../includes/HeaderAuth';

// function CookiesPage(props) {
class CookiesPage extends React.Component {
  componentDidMount() {
    window.scrollTo(0, 0);
  }
  render() {
    return (
      <div>
        <HeaderAuth colored type="/login" />
        <React.Fragment>
          <div
            style={{
              maxWidth: '1024px',
              marginLeft: 'auto',
              marginRight: 'auto',
            }}
          >
            <Grid
              spacing={0}
              container
              //alignItems={'center'}
              justify={'center'}
              spacing={0}
              className="template-terms"
            >
              <Grid item md={12} sm={11} xs={11}>
                <span className="last-update">
                  <span className="t-weight-b">Last update:</span> 07 March 2018
                </span>
                <h1 className="template-terms-main-title">Our Cookie Policy</h1>

                <TermsItem title="Note">
                  Welcome to our website. This website{' '}
                  <Link to="/">www.luminairebroker.arup.com</Link> (Site) is
                  owned and operated by ARUP Ltd. Should you continue to use the
                  Site, you are agreeing to comply with and be bound by the
                  following terms and conditions of use, which together with our
                  Privacy Policy govern ARUP Ltd’s relationship with you in
                  connection with this website. Should you not agree with any of
                  the terms and conditions in this Agreement, please do not use
                  the Site. Your use of this website is subject to the following
                  terms and conditions:
                </TermsItem>
                <TermsItem title="1. Type of information collected" olTitle>
                  Please read these terms of use carefully before you start to
                  use the Website, as these will apply to your use of the
                  website and the information you may find on it. We recommend
                  that you print a copy of this for future reference. By using
                  the Website, you confirm that you accept these terms of use
                  and that you agree to comply with them. If you do not agree to
                  these terms of use, you must not use the Website.
                </TermsItem>
                <TermsItem
                  title="2. Collection and use of personal information"
                  olTitle
                >
                  These terms of use refer to the following additional terms,
                  which also apply to your use of the Website: Our Privacy
                  Policy{' '}
                  <Link to="/privacy-policy">
                    www.luminairebroker.arup.com/privacy-policy
                  </Link>
                  , which sets out the terms on which we process any personal
                  data we collect from you, or that you provide to us. By using
                  the Website, you consent to such processing and you warrant
                  that all data provided by you is accurate. Our Cookie Policy{' '}
                  <Link to="/cookies">
                    www.luminairebroker.arup.com/cookies
                  </Link>
                  , which sets out information about the cookies on the Website.
                </TermsItem>
                <TermsItem
                  title="3. Disclosure of personal information"
                  olTitle
                >
                  Access to public parts of the Website is made available free
                  of charge. We do not guarantee that the Website, or any
                  content on it, will always be available or be uninterrupted.
                  Access to the Website is permitted on a temporary basis. We
                  may suspend, withdraw, discontinue or change all or any part
                  of the Website without notice. We will not be liable to you if
                  for any reason the Website is unavailable at any time or for
                  any period. You are responsible for making all arrangements
                  necessary for you to have access to the Website. You are also
                  responsible for ensuring that all persons who access the
                  Website through your internet connection are aware of these
                  terms of use and other applicable terms and conditions, and
                  that they comply with them. You will not be able to access
                  certain parts of the Website unless you are a registered
                  member and have been issued with a log-in name and password.
                  You must not seek to access any part of the website without a
                  valid log-in name and password.
                </TermsItem>
                <TermsItem title="4. Intellectual property rights" olTitle>
                  We are the owner and the licensee of all intellectual property
                  rights for the Website, and in the material published on it.
                  Those works are protected by copyright laws and treaties
                  around the world. All such rights are reserved. You must not
                  use any part of the content on the Website for commercial
                  purposes without obtaining a licence to do so from us or our
                  licensors.
                </TermsItem>
                <TermsItem title="5. Limitation of our liability" olTitle>
                  Nothing in these terms of use excludes or limits our liability
                  for death or personal injury arising from our negligence, or
                  our fraud or fraudulent misrepresentation, or any other
                  liability that cannot be excluded or limited by UK law. To the
                  extent permitted by law, we exclude all conditions,
                  warranties, representations or other terms which may apply to
                  the Website or any content on it, whether express or implied.
                  We will not be liable to any user for any loss or damage,
                  whether in contract, tort (including negligence), breach of
                  statutory duty, or otherwise, even if foreseeable, arising
                  under or in connection with:
                  <ul>
                    <li>use of, or inability to use, the Website; or</li>
                    <li>
                      use of, or reliance on any content displayed on the
                      Website.
                    </li>
                    <li>
                      If you are a business user, please note that, in
                      particular, we will not be liable for:
                    </li>
                    <ul>
                      <li>loss of profits, sales, business, or revenue;</li>
                      <li>business interruption;</li>
                      <li>loss of anticipated savings;</li>
                      <li>
                        loss of business opportunity, goodwill or reputation; or
                      </li>
                      <li>any indirect or consequential loss or damage.</li>
                    </ul>
                  </ul>
                  If you are a consumer user, please note that we only provide
                  the Website for domestic and private use. You agree not to use
                  the Website for any commercial or business purposes, and we
                  have no liability to you for any loss of profit, loss of
                  business, business interruption, or loss of business
                  opportunity. We will not be liable for any loss or damage
                  caused by a virus, distributed denial-of-service attack, or
                  other technologically harmful material that may infect your
                  computer equipment, computer programs, data or other
                  proprietary material due to your use of the Website or to your
                  downloading of any content on it, or on any website linked to
                  it. We assume no responsibility for the content of websites
                  linked on the Website. Such links should not be interpreted as
                  endorsement by us of those linked websites. We will not be
                  liable for any loss or damage that may arise from your use of
                  them.
                </TermsItem>
                <TermsItem
                  title="6. Third party links and resources in the web-site"
                  olTitle
                >
                  We are the owners of the licensee and all intellectual
                  property rights of the Website, and in the material published
                  on it. Those works are protected by copyright laws and
                  treaties around the world. All such rights are reserved. You
                  must not use any part of the content on the Website for
                  commercial purposes without obtaining a licence to do so from
                  us or our licensors.
                </TermsItem>
                <TermsItem title="7. Contact us" olTitle>
                  To contact us, please email{' '}
                  <a href="mailto:support@luminairebroker.arup.com">
                    support@luminairebroker.arup.com
                  </a>
                  . Thank you for visiting the Website.
                </TermsItem>
              </Grid>
            </Grid>
          </div>
          <Footer />
        </React.Fragment>
      </div>
    );
  }
}

export default CookiesPage;
